import React, {useState} from 'react'
import {Button, Card, Col, Form, InputGroup, Row} from "react-bootstrap";
import Dropdown, {components} from "react-select";
import {Formik} from 'formik';
import {RiArrowDownSFill} from "react-icons/ri";
import * as yup from 'yup';
import {
    AGGREGATED_DATA_INTERVAL_MAX,
    AGGREGATED_DATA_INTERVAL_MIN,
    AGGREGATED_DATA_RESOLUTION_MAX,
    AGGREGATED_DATA_RESOLUTION_MIN,
    FACTORY_DEFAULTS,
    KEEP_ALIVE_INTERVAL_MAX,
    KEEP_ALIVE_INTERVAL_MIN,
    REBOOT,
    RESET
} from "./Types";
import PromptModal from "./PromptModal";

export default function OptionsPage({
                                        keepAliveInterval,
                                        aggregatedDataInterval,
                                        aggregatedDataResolution,
                                        logLevel,
                                        setKeepAliveInterval,
                                        setAggregatedDataInterval,
                                        setAggregatedDataResolution,
                                        setLogLevel,
                                        controlUnitService,
                                        controlUnitId,
                                        lifecyclePhase,
                                        setLifecyclePhase
                                    }) {
    const [promptMessage, setPromptMessage] = useState(null);
    const [promptAction, setPromptAction] = useState(null);
    const [showModal, setShowModal] = useState(null);
    const [isRequestInProgress, setIsRequestInProgress] = useState(false);
    const [showError, setShowError] = useState(false);
    const environment = process.env.REACT_APP_ENV;


    const logLevelOptions = [
        {
            value: 'FATAL',
            label: 'Fatal'
        },
        {
            value: 'ERROR',
            label: 'Error'
        },
        {
            value: 'WARNING',
            label: 'Warning'
        }
        ,
        {
            value: 'INFO',
            label: 'Info'
        },
        {
            value: 'DEBUG',
            label: 'Debug'
        }
    ];

    const lifecyclePhaseOptions = [
        {value: 'ENROLLED', label: 'Enrolled'},
        {value: 'PRE_SERVICE', label: 'Pre-Service'},
        {value: 'IN_SERVICE', label: 'In-Service'},
        {value: 'INTERNAL_USE', label: 'Internal Use'},
        {value: 'DECOMMISSIONED', label: 'Decommissioned'},
        {value: 'HARDWARE_DONOR', label: 'Hardware Donor'},
    ];

    const customDropdownStyles = {
        control: (provided) => ({
            fontSize: 14,
            ...provided
        }),
        option: (provided) => ({
            ...provided,
            fontSize: 14,
            minHeight: 40,
        })
    }

    const schema = yup.object().shape({
        keepAliveInterval: yup.number().min(KEEP_ALIVE_INTERVAL_MIN, `Must be greater than or equal to ${KEEP_ALIVE_INTERVAL_MIN}`).max(KEEP_ALIVE_INTERVAL_MAX, `Must be less than or equal to ${KEEP_ALIVE_INTERVAL_MAX}`).required('Required field'),
        aggregatedDataInterval: yup.number().min(AGGREGATED_DATA_INTERVAL_MIN, `Must be greater than or equal to ${AGGREGATED_DATA_INTERVAL_MIN}`).max(AGGREGATED_DATA_INTERVAL_MAX, `Must be less than or equal to ${AGGREGATED_DATA_INTERVAL_MAX}`).required('Required field'),
        aggregatedDataResolution: yup.number().min(AGGREGATED_DATA_RESOLUTION_MIN, `Must be greater than or equal to ${AGGREGATED_DATA_RESOLUTION_MIN}`).max(AGGREGATED_DATA_RESOLUTION_MAX, `Must be less than or equal to ${AGGREGATED_DATA_RESOLUTION_MAX}`).required('Required field'),
        logLevel: yup.string().required(),
    });

    const DropdownIndicator = props => {
        return (components.DropdownIndicator && (<components.DropdownIndicator {...props}>
            <RiArrowDownSFill color={'black'} size={20}/>
        </components.DropdownIndicator>));
    };

    const getLogLevelValue = (value) => {
        if (!value) {
            return logLevelOptions[3]
        }
        return logLevelOptions.filter((option) => option.value === value);
    }

    const getLifecyclePhaseValue = (value) => {
        if (!value) {
            return null;
        }
        return lifecyclePhaseOptions.find((option) => option.value === value);
    }

    const handlePrompt = async () => {
        switch (promptAction) {
            case FACTORY_DEFAULTS: {
                await handleResetToFactoryDefaults();
                break;
            }
            case RESET: {
                await handleResetServices();
                break;
            }
            case REBOOT: {
                await handleRebootDevice();
                break;
            }
        }
    }

    const handleResetToFactoryDefaults = async () => {
        try {
            setIsRequestInProgress(true);
            await controlUnitService.resetToFactoryDefaults(controlUnitId);
            setIsRequestInProgress(false);
            setShowModal(false);
            setShowError(false);
        } catch (e) {
            setIsRequestInProgress(false);
            setShowError(true);
        }
    }

    const handleResetServices = async () => {
        try {
            setIsRequestInProgress(true);
            await controlUnitService.resetServices(controlUnitId);
            setIsRequestInProgress(false);
            setShowModal(false);
            setShowError(false);
        } catch (e) {
            setIsRequestInProgress(false);
            setShowError(true);
        }
    }

    const handleRebootDevice = async () => {
        try {
            setIsRequestInProgress(true);
            await controlUnitService.rebootDevice(controlUnitId);
            setIsRequestInProgress(false);
            setShowModal(false);
            setShowError(false);
        } catch (e) {
            setIsRequestInProgress(false);
            setShowError(true);
        }
    }

    {
        return (
            <>
                <PromptModal showError={showError}
                             setShowError={setShowError}
                             isRequestInProgress={isRequestInProgress}
                             show={showModal} setShow={setShowModal}
                             handlePrompt={handlePrompt}
                             promptMessage={promptMessage}/>
                <Row style={{marginRight: '230px'}} className={'mb-2 ml-1'}>
                    <Col md={{span: 6, offset: 4}}>
                        <Formik
                            enableReinitialize
                            validateOnMount
                            validationSchema={schema}
                            initialValues={{
                                keepAliveInterval: keepAliveInterval,
                                aggregatedDataInterval: aggregatedDataInterval,
                                aggregatedDataResolution: aggregatedDataResolution,

                            }}
                        >
                            {({
                                  handleSubmit,
                                  setFieldValue,
                                  values,
                                  errors,
                              }) => (
                                <Form noValidate onSubmit={handleSubmit}>


                                    <Card bsPrefix='tabCard'>


                                        <Card.Body>
                                            <Form.Group as={Row} controlId="formPlaintextEmail">
                                                <Form.Label column sm="5">
                                                    <div style={{textAlign: "right"}}>Keep Alive Interval (Minutes):
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <InputGroup hasvalidation>
                                                        <Form.Control
                                                            type="number"
                                                            name="keepAliveInterval"
                                                            value={values.keepAliveInterval}
                                                            onChange={(e) => {
                                                                setFieldValue("keepAliveInterval", e.target.value);
                                                                setKeepAliveInterval(e.target.value);
                                                            }}
                                                            isInvalid={!!errors.keepAliveInterval}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.keepAliveInterval}
                                                        </Form.Control.Feedback>
                                                    </InputGroup>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} controlId="formPlaintextPassword">
                                                <Form.Label column sm="5">
                                                    <div style={{textAlign: "right"}}>Aggregated Data Interval
                                                        (Minutes):
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <InputGroup hasvalidation>
                                                        <Form.Control
                                                            type="number"
                                                            name="aggregatedDataInterval"
                                                            value={values.aggregatedDataInterval}
                                                            onChange={(e) => {
                                                                setFieldValue("aggregatedDataInterval", e.target.value);
                                                                setAggregatedDataInterval(e.target.value);
                                                            }}
                                                            isInvalid={!!errors.aggregatedDataInterval}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.aggregatedDataInterval}
                                                        </Form.Control.Feedback>
                                                    </InputGroup>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} controlId="formPlaintextPassword">
                                                <Form.Label column sm="5">
                                                    <div style={{textAlign: "right"}}>Aggregated Data Resolution
                                                        (Minutes):
                                                    </div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <InputGroup hasvalidation>
                                                        <Form.Control
                                                            type="number"
                                                            name="aggregatedDataResolution"
                                                            value={values.aggregatedDataResolution}
                                                            onChange={(e) => {
                                                                setFieldValue("aggregatedDataResolution", e.target.value);
                                                                setAggregatedDataResolution(e.target.value);
                                                            }}
                                                            isInvalid={!!errors.aggregatedDataResolution}
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            {errors.aggregatedDataResolution}
                                                        </Form.Control.Feedback>
                                                    </InputGroup>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} controlId="formPlaintextPassword">
                                                <Form.Label column sm="5">
                                                    <div style={{textAlign: "right"}}>Log Level:</div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Dropdown
                                                        value={getLogLevelValue(logLevel)}
                                                        styles={customDropdownStyles}
                                                        options={logLevelOptions}
                                                        onChange={(value) => {
                                                            setLogLevel(value.value);
                                                        }}
                                                        components={{
                                                            IndicatorSeparator: () => null, DropdownIndicator
                                                        }}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <Form.Group as={Row} controlId="formLifecyclePhase">
                                                <Form.Label column sm="5">
                                                    <div style={{textAlign: "right"}}>Lifecycle Phase:</div>
                                                </Form.Label>
                                                <Col sm="6">
                                                    <Dropdown
                                                        value={getLifecyclePhaseValue(lifecyclePhase)}
                                                        styles={customDropdownStyles}
                                                        options={lifecyclePhaseOptions}
                                                        onChange={(value) => {
                                                            setLifecyclePhase(value.value);
                                                        }}
                                                        components={{
                                                            IndicatorSeparator: () => null, DropdownIndicator
                                                        }}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            <div className='d-inline mt-5'>
                                                <div className='d-inline  m-2'>
                                                    {
                                                        !(environment === 'prod') &&
                                                        <Button
                                                            onClick={() => {
                                                                setPromptMessage('Are you sure you want to reset to factory defaults?');
                                                                setPromptAction(FACTORY_DEFAULTS);
                                                                setShowModal(true);
                                                            }}
                                                        > Reset To Factory Default </Button>
                                                    }
                                                </div>
                                                <div className='d-inline  m-2'>
                                                    <Button onClick={() => {
                                                        setPromptMessage('Are you sure you want to reset the services?');
                                                        setPromptAction(RESET);
                                                        setShowModal(true);
                                                    }}> Reset Services</Button>
                                                </div>
                                                <div className='d-inline m-2'>
                                                    <Button onClick={() => {
                                                        setPromptMessage('Are you sure you want to reboot the device?');
                                                        setPromptAction(REBOOT);
                                                        setShowModal(true);
                                                    }}> Reboot Device</Button>
                                                </div>
                                            </div>

                                        </Card.Body>
                                    </Card>
                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </>

        )
    }
}
